import {
  IProviderOption,
  Provider,
} from "@/components/excel/schema/definiens/provider";
import { AreaSharedCache } from "@/utils/AreaSharedCache";
import {
  CityOption,
  CountyOption,
  ProvinceOption,
} from "@/components/excel/schema/label/type/area";

function getAreaItemName(id: number) {
  const item = AreaSharedCache.getItem(id);
  return item?.name ?? `${id}`;
}

function areaProvider(option: IProviderOption): string[] {
  const names: string[] = [];
  option.value.forEach((item: number | number[]) => {
    if (Array.isArray(item)) {
      if (option.showPrefix) {
        const name = item
          .map((it) => getAreaItemName(it))
          .join(option.separator);
        names.push(name);
      } else {
        names.push(getAreaItemName(item[item.length - 1]));
      }
    } else {
      names.push(getAreaItemName(item));
    }
  });
  return names;
}

export const AreaNameProvider: { [key: number]: Provider } = {
  [ProvinceOption.value]: areaProvider,
  [CityOption.value]: areaProvider,
  [CountyOption.value]: areaProvider,
};
